import MazhrModal from "../reusableElementsComponents/MazhrModal";
import MazhrStepper from '../reusableElementsComponents/MazhrStepper';
import TeamReviewGeneral from './TeamReviewGeneral';
import TeamReviewAssessments from './TeamReviewAssessments';
import { useMemo, useState } from "react";
import { toast } from 'react-toastify';
import B2BApiService from "../../B2bApiService";
import { t } from '../../content';

function InviteTeamModal({ modalShow, modalHide, refreshAllTeamsData }) {

    const [generalData, setGeneralData] = useState({
        title: "",
        description: "",
        industry: "",
        // member_list: [],
    });
    const [assessmentData, setAssessmentData] = useState({
        assessments: []
    });

    const b2bServiceObj = useMemo(() => {
        return new B2BApiService();
    }, []);

    const onNewTeamSave = (saved) => {
        if (saved) {
            refreshAllTeamsData();
            modalHide()
            setGeneralData({
                title: "",
                description: "",
                industry: "",
            });
            setAssessmentData({
                assessments: []
            });
            toast.success(t('teams.toasts.created'), {containerId: "teamManagementToast"});
        } else {
            toast.error(t('teams.toasts.createError'), {containerId: "teamManagementToast"});
        }
        
    }

    const saveTeam = () => {
        let submittedData = { 
            title: generalData.title,
            description: generalData.description,
            industry_id: generalData.industry.id,
            // member_list: generalData.member_list,
            assessments: assessmentData.assessments
        };
        b2bServiceObj.SaveTeam(submittedData, onNewTeamSave);
    }
    return (
        <>
            <MazhrModal
                show={modalShow}
                onHide={modalHide}
            >
                <MazhrStepper
                    step1={<TeamReviewGeneral data={generalData} updateData={setGeneralData}/>}
                    step2={<TeamReviewAssessments data={assessmentData} updateData={data => setAssessmentData({assessments: data})} />}
                    optionalSteps={[2]}
                    submitFunction={saveTeam}
                />

            </MazhrModal>
        </>
    )
}

export default InviteTeamModal;
